import { render, staticRenderFns } from "./SuppliersRegistryNewFormTab.vue?vue&type=template&id=27909265"
import script from "./SuppliersRegistryNewFormTab.vue?vue&type=script&lang=js"
export * from "./SuppliersRegistryNewFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports